import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import '../styles/dashboard.css';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsProgress, faClockRotateLeft, faChartPie, faSignOutAlt, faUserPlus, faList, faHouse, faUser, faCircleDot, faBriefcase, faBusinessTime, faListCheck, faCalendarDays, faBuilding, faBars, faCaretDown, faCaretRight, faUserTie, faKey } from '@fortawesome/free-solid-svg-icons';
import DepartmentPage from './department';
import LedgerGroupPage from './ledgerGroup'
import LedgerMasterPage from './ledgerMaster';
import PurposePage from './purpose'
import ItemGroupPage from './itemGroup';
import SewadarForm from './Sewadar';
import ItemMaster from './itemMaster';
import SecurityIn from './SecurityIn';
import AddCenter from './addCenter';
import CenterIncharge from './CenterIncharge';
import DeliveryChallan from './deliveryChallan';
import CenterList from './centerList';
import UOMList from './uomList';
import LocationList from './locationList';
import AddInventory from './addInventory';
import LessInventory from './lessInventory';
import PurposeInventory from './purposeInventory';
import ReceiptVoucher from './receiptVoucher';
import GatePass from './gatePass';
import SecurityOutForm from './SecurityOut';
import ITManager from './itManager';
import DepartmentItem from './departmentalItemsReport';
import DepartmentInventory from './DepartmentInventory'
import ItemGroupType from './ItemGroupTypeReport';
import IssueRequest from './issueRequest';
import DeliveryChallanList from './deliveryChallanList';
import PermissionsPage from './permissions';
import IssueSlip from './issueSlip';
import ReturnSlip from './returnSlip';
import { hasPermission } from '../utils/usePermissions';
import GlobalItemTransactionReport from './GlobalItemTransactionReport';
import Additions from './additionsList';
import Deductions from './deductions';
import ReturnAcceptance from './returnAcceptance';
import ItemMasterApproval from './ApproveIteMaster';
import OpeningStock from './OpeningStock';
import OpeningStockList from './OpeningStockList';
import MMSMapping from './MMSMapping';
import DepartmentItemTransactionReport from './DepartmentItemTransactionReport';
import StatusWiseReport from './StatusWiseReport';
import EventWiseReport from './EventWiseReport';
import OpeningStockReport from './OpeningStockReport';
import SewadarList from './sewadarList';
import AddSewadarForm from './AddSewadar';
import Operator from './operator';
import OperatorList from './operatorList';
import ItemMasterForm from './ItemMasterForm';
import InventoryLocationTransfer from './InventoryLocationTransfer';
import LedgerMasterList from './ledgerMasterList';
import AddAreaProjects from './addAreaProjects';
import AreaProjectList from './areaProjectList';
import ItemMasterList from './ItemMasterList';
import SewadarHomePage from './SewadarHomePage';
import InventoryLocationTranferList from './InventoryLocationTranferList';
import InventoryStatusTransfer from './InventoryStatusTransfer';
import InventoryStatusTransferList from './InventoryStatusTransferList';
import ApproveLedgerMaster from './approveLedgers';
import LedgerMasterApproverForm from './ledgerMasterApproverForm';
import SecurityInListing from './SecurityInListing';
import ItemAnalysisReport from './ItemAnalysisReport';
import DepartmentItemAnalysisReport from './DepartmentItemAnalysisReport';
import ReceiptVoucherList from './ReceiptVoucherList';
import GatePassList from './gatePassList';
import ItemConversion from './ItemConversion';
import ItemConversionList from './ItemConversionList';
import MMSMappingForm from './MMSMappingForm';
import VehicleMaster from './vehicleMaster';
import VehicleMasterList from './vehicleMasterList';
import MRInfo from './MRInfo';
import MRList from './MRList';
import PurposeListing from './purposeListing';
import IssueSlipTable from './IssueSlipTable';
import IssueRequestTable from './IssueRequestTable';
import ReturnSlipTable from './returnSlipTable';
import ReturnAcceptanceTable from './returnAcceptanceTable';
import ChangePinModal from './changePinModal';
import TestingDeliveryChallan from './DeliverChallanTesting';
import DeliveryChallanListTesting from './deliveryChallanTestingList';
import ExceptionalSecurityOut from './ExceptionalSecurityOut';
import BillDetails from './BillDetails';
import AddSiBill from './AddSiBills';
import OpeningStockLedger from './OpeningStockLedger';
import OpeningStockLedgerList from './OpeningStockLedgerList';
import AddInventoryLedger from './addInventoryLedger';
import AdditionsLedger from './additionListLedger';
import LessInventoryLedger from './lessInventoryLedger';
import DeductionsLedger from './deductionLedger';
import LedgerInventoryReport from './LedgerInventoryReport';
import SewadarLoginLogs from './SewadarLoginReport';
import ModulePermissionReport from './ModulePermissionReport';
import UnusableProduction from './UnusableProduction';
import UnusableProductionList from './UnusableProductionList';
import InventoryMasterListing from './InventoryMasterList';
import TransactionEntry from './transactionEntry';
import TransactionEntryList from './transactionEntryListy';
import ItemApprovalReport from './ItemApprovalReport';
import LedgerApprovalReport from './LedgerApprovalReport';
import SewadarReport from './SewadarReport';
import ItemMasterApprovall from './ApproveItemMaster';
import FuelReport from './fuelReport';
import FuelConsumptionReport from './fuelConsumptionReport';
import TransactionAccMgt from './transactionAccMgt';
import ProjectRequirement from './projectRequirement';
import ProjectRequirementList from './projectRequirementList';
import VoucherStatusHandler from './voucherStatusHandler';
import PendingReturnableReport from './pendingReturnable';
import PendingTransactionReport from './PendingTransactionReport';
import RequirementAssessmentListing from './requirementAssessmentList';
import DepartmentWiseReports from './DepartmentWiseReports';
import ItemAndGroupAnalysisReports from './ItemAndGroupAnalysisReports';
import ItemLedgerReports from './ItemLedgerReports';
import VoucherWiseLedgerInventory from './LedgerVoucherReport';
import LedgerWiseReports from './LedgerWiseReports';
import ReceiptAllocation from './receiptAllocation';
import PendingSIReport from './PendingSIReport';
import ConfirmationLetterList from './confirmationletterList';
import DepartmentReceiptVoucher from './departmentReceiptVoucher';
import SeriesMaster from './seriesMaster';
import SeriesMasterList from './seriesMasterList';
import Recipe from './recipe';
import RecipeMasterList from './recipeMasterList';
import VoucherReceiving from './voucherReceiving';
import RecipeConsumption from './recipeConsumption';
import RecipeConsumptionList from './recipeConsumptionList';
import DonationLetterList from './donationList';
import ReceiptPendingReturnableReport from './receiptPendingReturnable';
import AdminReports from './adminReports';
import CanteenSale from './canteenSale';
import CanteenSaleList from './canteenSaleList';

const Swal = require('sweetalert2');

const Navbar = () => {
  const navigate = useNavigate();
  //
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [activeLink, setActiveLink] = useState('Dashboard');
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [refNo, setRefNo] = useState('');
  const [sewadars, setSewadars] = useState([]);
  const [centerInfo, setCenterInfo] = useState([]);
  const [prefix, setPrefix] = useState('');
  const [toggleStates, setToggleStates] = useState({
    center: false,
    masters: false,
    securityFunctions: false,
    itemInward: false,
    itemOutward: false,
    departmentFunctions: false,
    letters: false,
    reports: false,
    requisition: false,
    adminstration: false,
    ledgerFunctions: false,
    adminReports: false,
    voucherManagement:false,
    accountsManagement:false
  });
  const name = localStorage.getItem('name')
  const centerCode = localStorage.getItem('code');
  const role = localStorage.getItem('role');
  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const username = localStorage.getItem('username');
  const sewadarId = localStorage.getItem("sewadarId");
  const [showChangePinModal, setShowChangePinModal] = useState(false);
  const [pin, setPin] = useState("");
  const [password, setPassword] = useState("");
  const [permissions, setPermissions] = useState([])

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleNavHeading = (heading) => {
    setToggleStates((prev) => ({ ...prev, [heading]: !prev[heading] }));
  };
  const handleLinkClick = (link) => {
    if (unsavedChanges) {
      // Prevent the default navigation and show the confirmation alert
      Swal.fire({
        title: "You have unsaved changes!",
        text: "Are you sure you want to leave this page?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Leave",
        cancelButtonText: "Stay",
      }).then((result) => {
        if (result.isConfirmed) {
          // If confirmed, navigate to the stored link
          setUnsavedChanges(false);
          handleDelete()
          navigate(link); // Perform the navigation
        }
      });
    } else {
      // If no unsaved changes, navigate immediately
      navigate(link);
    }
  };
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (unsavedChanges) {
        event.preventDefault();
        event.returnValue = ''; // Required for modern browsers
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [unsavedChanges]);

  useEffect(() => {
    fetchSewadar();
  }, [centerCode, email]); // Re-fetch departments when centerCode changes


  useEffect(() => {
    fetchCenterInfo();
  }, [centerCode]);
  const fetchSewadar = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/getSewadarDetails', {
        params: { code: centerCode, email, username },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSewadars(response.data[0]);

      let rawPermissions = response.data[0]?.permissions;
      const parsedPermissions = rawPermissions ? JSON.parse(rawPermissions) : {};
      setPermissions(parsedPermissions);
    } catch (error) {
      console.error('Error fetching Sewadars:', error);
    }
  };

  const handleCloseModal = () => {
    setShowChangePinModal(false);
    setPin("");
    setPassword("");
  };
  const handleLogout = () => {
    Swal.fire({
      title: 'Do you want to log out?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      icon: 'warning',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        localStorage.clear();
        navigate('/');
      }
    });
  };

  const handleDelete = async () => {
    try {
      await apiClient.delete(`${SERVER_BASE}/deleteModalData`, {
        params: { refNo, prefix, centerCode }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      // Swal.fire(' deleted.', 'success');
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };
  const fetchCenterInfo = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
        params: { code: centerCode },
        headers: { 'Authorization': `Bearer ${token}` },
      });

      const center = response.data[0];
      setCenterInfo(center);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  return (
    <>
      <div className="top-navbar">
        <div className="top-navbar-content">
          <div className="toggle-btn" onClick={toggleNavbar}>
            <FontAwesomeIcon icon={faBars} />
          </div>
          <div className="">
            <span className="" style={{ marginRight: '3px', width: "610px", fontSize: "0.9rem", borderRadius: "8px", padding: "8px", backgroundColor: 'white', color: 'black' }}
            >
              Radha Soami Satsang Beas , NH-52 Tonk Road Bilwa Jaipur</span>

            <span className="" style={{ width: "25%", fontSize: "0.9rem", borderRadius: "8px", padding: "8px", backgroundColor: 'white', color: 'black', marginRight: '3px' }}
            >
              Center - Bilwa, Jaipur-I</span>
            <span className="" style={{ width: "30%", fontSize: "0.9rem", borderRadius: "8px", padding: "8px", backgroundColor: 'white', color: 'black' }}
            >
              2025-2026</span>
            <span className="admin-welcome" style={{ width: "20%", fontSize: "0.9rem", borderRadius: "8px", padding: "8px" }}>
              {name} - {sewadars ? sewadars?.sewadarOf : ''}
            </span>
          </div>

          <div className="d-flex align-items-center">
            <div className="dropdown ms-2">
              <button
                className="btn btn-light border-0 "
                type="button"
                id="profileMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faUserTie} />
              </button>

              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="profileMenu"
              >
                <li>
                  <span className="dropdown-item-text fw-bold">
                    {name}
                  </span>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => setShowChangePinModal(true)}
                  >
                    <FontAwesomeIcon icon={faKey} className="me-2" />
                    Change Pin
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={handleLogout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                    Logout
                  </button>
                </li>
              </ul>
              <ChangePinModal
                show={showChangePinModal}
                onClose={handleCloseModal}
                pin={pin}
                setPin={setPin}
                password={password}
                setPassword={setPassword}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="admin-dashboard">
        <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
          <div className="logo-section">
            <div className="toggle-btn" onClick={toggleNavbar}>
              {isCollapsed ? '>' : '<'}
            </div>
          </div>
          <ul className="nav flex-column">
            <Link to="" className='colourlink'>
              <li
                className={`nav-item ${activeLink === 'Dashboard' ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault(); // Prevent default Link behavior
                  handleLinkClick(''); // Pass the correct link to handleLinkClick
                  setActiveLink('Dashboard');
                }}
              >
                <FontAwesomeIcon icon={faHouse} />
                {/* Only show the text if the navbar is not collapsed */}
                {!isCollapsed && <span>Dashboard</span>}
              </li>
            </Link>
            {(role === 'superAdmin' || role === 'center') && <>
              <li className="nav-heading" onClick={() => toggleNavHeading('center')}>
                {toggleStates.center ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Center Info'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Center Info'}
                  </>
                )}
              </li>

              {toggleStates.center && (
                <>
                  {role === 'superAdmin' && <>
                    <Link to="centerList" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'Center List' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('centerList');
                          setActiveLink('Center List');
                        }}

                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>Center List</span>}
                      </li>
                    </Link>
                    <Link to="addCenterIncharge" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'AS Details' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('addCenterIncharge');
                          setActiveLink('AS Details');
                        }}
                      >
                        <FontAwesomeIcon icon={faUserPlus} />
                        {!isCollapsed && <span>AS Details</span>}
                      </li>
                    </Link>
                  </>
                  }
                  {(role === 'center') && <>
                    <Link to="itManager" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'IT Manager' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('itManager')
                          setActiveLink('IT Manager');
                        }}
                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>IT Manager</span>}
                      </li>
                    </Link>
                  </>}

                </>
              )}
            </>}

            {(role == 'itManager' || hasPermission(permissions, ['operator']) || hasPermission(permissions, ['department']) || hasPermission(permissions, ['stores']) || hasPermission(permissions, ['sewadar']) || hasPermission(permissions, ['ledgerGroup']) || hasPermission(permissions, ['ledgerMaster']) || hasPermission(permissions, ['purposeLedger']) || hasPermission(permissions, ['itemGroup']) || hasPermission(permissions, ['itemMaster']) || hasPermission(permissions, ['itemEvent']) || hasPermission(permissions, ['uom']) || hasPermission(permissions, ['mmsMaping']) || hasPermission(permissions, ['vehicleMaster'])|| hasPermission(permissions, ['recipe'])) && (
              <li className="nav-heading" onClick={() => toggleNavHeading('masters')}>
                {toggleStates.masters ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Masters'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Masters'}
                  </>
                )}
              </li>
            )}
            {toggleStates.masters && (
              <>
                {(role == 'itManager'
                ) && (
                  <Link to="SeriesMasterList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'seriesMaster' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('SeriesMasterList');
                        setActiveLink('SeriesMasterList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Series Master</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['department'])
                ) && (
                    <Link to="department" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'Department' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('department');
                          setActiveLink('Department');
                        }}

                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>Department</span>}
                      </li>
                    </Link>
                  )}
                {(role == 'itManager' || hasPermission(permissions, ['stores'])) && (
                  <Link to="locationList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Location List' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('locationList');
                        setActiveLink('Location List');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Stores & Areas</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['sewadar'])) && (
                  <Link to="sewadarList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'sewadarList' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('sewadarList');
                        setActiveLink('sewadarList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Sewadars</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['ledgerGroup'])) && (
                  <Link to="ledgerGroup" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Ledger Group' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ledgerGroup');
                        setActiveLink('Ledger Group');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger Group</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['ledgerMaster'])) && (
                  <Link to="ledgerMaster" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Ledger Master' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ledgerMaster');
                        setActiveLink('Ledger Master');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger Master</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['purposeLedger'])) && (
                  <Link to="purposeLedger" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Purpose - Ledger' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('purposeLedger');
                        setActiveLink('Purpose - Ledger');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger - Purpose</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['itemGroup'])) && (
                  <Link to="itemGroup" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Inventory Group' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('itemGroup');
                        setActiveLink('Inventory Group');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Inventory Group</span>}
                    </li>
                  </Link>
                )}
                {/* {(role == 'itManager' || hasPermission(permissions, ['itemMaster'])) && (
                  <Link to="ItemMasterList" className='colourlink'>
                  <li
                    className={`nav-item ${activeLink === 'Inventory Master' ? 'active' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('ItemMasterList');
                      setActiveLink('Inventory Master');
                    }}
                  >
                    <FontAwesomeIcon icon={faBarsProgress} />
                    {!isCollapsed && <span>Inventory Master</span>}
                  </li>
                  </Link>
                )} */}
                {(role == 'itManager' || hasPermission(permissions, ['itemMaster'])) && (
                  <Link to="InventoryMasterListing" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Inventory Master' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('InventoryMasterListing');
                        setActiveLink('Inventory Master');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Inventory Master</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['mmsMaping'])) && (
                  <Link to="MMSMapping" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'MMS Mapping' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('MMSMapping');
                        setActiveLink('MMS Mapping');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Inventory Master - MMS</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['itemEvent'])) && (
                  <Link to="purposeInventory" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Purpose - Inventory' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('purposeInventory');
                        setActiveLink('Purpose - Inventory');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Inventory - Event</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['uom'])) && (
                  <Link to="uomList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'UOM List' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('uomList');
                        setActiveLink('UOM List');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>UOM</span>}
                    </li>
                  </Link>
                )}
                {(role == 'itManager' || hasPermission(permissions, ['vehicleMaster'])) && (
                  <Link to="VehicleMasterList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Vehicle Master' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('VehicleMasterList');
                        setActiveLink('Vehicle Master');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Vehicle Master</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['operator'])) && (
                  <Link to="operatorList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'Operator' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('operatorList');
                        setActiveLink('Operator');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Operator</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['recipe'])) && (
                  <Link to="recipeList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'Recipe List' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('recipeList');
                        setActiveLink('Recipe List');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Recipe</span>}
                    </li>
                  </Link>
                )}
               
                {(role == 'itManager') && (<>
                  <Link to="itemApproval" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Item Master Approval' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('itemApproval');
                        setActiveLink('Item Master Approval');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Item Master Approval</span>}
                    </li>
                  </Link>
                  {/* <Link to="ItemMasterApproval" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'ItemMasterApproval' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ItemMasterApproval');
                        setActiveLink('ItemMasterApproval');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span> NEW Item Master Approval</span>}
                    </li>
                  </Link> */}
                  <Link to="ledgerApproval" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Ledger Master Approval' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ledgerApproval');
                        setActiveLink('Ledger Master Approval');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger Master Approval</span>}
                    </li>
                  </Link>
                </>
                )}
              </>
            )}
            {(role == 'itManager') && (
              <li className="nav-heading" onClick={() => toggleNavHeading('adminReports')}>
                {toggleStates.adminReports ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' IT Admin Reports'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' IT Admin Reports'}
                  </>
                )}
              </li>
            )}
            {toggleStates.adminReports && (
              <>
                {(role == 'itManager') && (<>
                  <Link to="SewadarLoginLogs" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'SewadarLoginLogs' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('SewadarLoginLogs');
                        setActiveLink('SewadarLoginLogs');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Sewadar Login Report</span>}
                    </li>
                  </Link>
                  <Link to="ModulePermissionReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'ModulePermissionReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ModulePermissionReport');
                        setActiveLink('ModulePermissionReport');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Module Permission Report</span>}
                    </li>
                  </Link>
                  <Link to="ItemApprovalReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'ItemApprovalReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ItemApprovalReport');
                        setActiveLink('ItemApprovalReport');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Item Approval Report</span>}
                    </li>
                  </Link>
                  <Link to="LedgerApprovalReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'LedgerApprovalReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('LedgerApprovalReport');
                        setActiveLink('LedgerApprovalReport');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger Approval Report</span>}
                    </li>
                  </Link>
                  <Link to="sewadarReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'sewadarReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('sewadarReport');
                        setActiveLink('sewadarReport');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Sewadar Report</span>}
                    </li>
                  </Link>
                </>)}
              </>
            )}
                        {(role == 'itManager') && (
              <li className="nav-heading" onClick={() => toggleNavHeading('voucherManagement')}>
                {toggleStates.voucherManagement ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Voucher Management'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Voucher Management'}
                  </>
                )}
              </li>
            )}
                        {toggleStates.voucherManagement && (
              <>
                {(role == 'itManager') && (<>
                  <Link to="tam" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'tam' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('tam');
                        setActiveLink('Transaction Accounts Management');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Vch Inventory Mgm</span>}
                    </li>
                  </Link>
                  <Link to="VoucherStatusHandler" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'VoucherStatusHandler' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('VoucherStatusHandler');
                        setActiveLink('VoucherStatusHandler');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Vch Reversal</span>}
                    </li>
                  </Link>
                  <Link to="PendingTransactionReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'PendingTransactionReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('PendingTransactionReport');
                        setActiveLink('PendingTransactionReport');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Vch Pendencies</span>}
                    </li>
                  </Link>
               
                </>)}
              </>
            )}
            {(hasPermission(permissions, ['receiptVoucher']) || hasPermission(permissions, ['additions'])) && (
              <li className="nav-heading" onClick={() => toggleNavHeading('itemInward')}>
                {toggleStates.itemInward ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Inward'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Inward'}
                  </>
                )}
              </li>
            )}
            {toggleStates.itemInward && (
              <>
                {(hasPermission(permissions, ['receiptVoucher'])) && (
                  <>
                    <Link to="ReceiptVoucherList" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'Receipt Voucher List' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('ReceiptVoucherList');
                          setActiveLink('Receipt Voucher List');
                        }}
                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>Receipt Voucher</span>}
                      </li>
                    </Link>
                  </>
                )}
                {(hasPermission(permissions, ['additions'])) && (
                  <Link to="additions" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Additions' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('additions');
                        setActiveLink('Additions');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Additions</span>}
                    </li>
                  </Link>
                )}
              </>
            )}
            {(hasPermission(permissions, ['deliveryChallan']) || hasPermission(permissions, ['deductions']) || hasPermission(permissions, ['gatePass']) ||hasPermission(permissions, ['recipeConsumption'])) && (
              <li className="nav-heading" onClick={() => toggleNavHeading('itemOutward')}>
                {toggleStates.itemOutward ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Outward'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Outward'}
                  </>
                )}
              </li>
            )}
            {toggleStates.itemOutward && (
              <>
                {(hasPermission(permissions, ['deliveryChallan'])) && (
                  <Link to="DeliveryChallanList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Delivery Challan List ' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('DeliveryChallanList');
                        setActiveLink('Delivery Challan List ');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Delivery Challan </span>}
                    </li>
                  </Link>
                )}
                {(sewadarId == '23' || sewadarId == '26' || sewadarId == '29') && (
                  <Link to="TestingDeliveryChallanList  " className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Testing Delivery Challan List ' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('TestingDeliveryChallanList');
                        setActiveLink('Testing Delivery Challan List ');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Testing Delivery Challan </span>}
                    </li>
                  </Link>
                )}

                {(hasPermission(permissions, ['deductions'])) && (
                  <Link to="deductions" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'Deductions' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('deductions');
                        setActiveLink('Deductions');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Deductions</span>}
                    </li>
                  </Link>
                )}

                {(hasPermission(permissions, ['gatePass'])) && (
                  <Link to="gatePassList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'Gate Pass' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('gatePassList');
                        setActiveLink('Gate Pass');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Gate Pass</span>}
                    </li>
                  </Link>
                )}
              {(hasPermission(permissions, ['recipeConsumption'])) && (
               
               <Link to="RecipeConsumptionList" className='colourlink'>
                 <li
                   className={`nav-item ${activeLink === 'RecipeConsumptionList' ? 'active' : ''}`}
                   onClick={(e) => {
                     e.preventDefault();
                     handleLinkClick('RecipeConsumptionList');
                     setActiveLink('RecipeConsumptionList');
                   }}
                 >
                   <FontAwesomeIcon icon={faBarsProgress} />
                   {!isCollapsed && <span>Recipe Consumption</span>}
                 </li>
               </Link>
             )}
              </>
            )}
            {(hasPermission(permissions, ['openingStock']) || hasPermission([permissions, 'locationTransfer']) || hasPermission(permissions, ['statusTransfer']) || hasPermission(permissions, ['itemConversion'])) && (
              <li className="nav-heading" onClick={() => toggleNavHeading('departmentFunctions')}>
                {toggleStates.departmentFunctions ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ` Deptt's Function`}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ` Deptt's Function`}
                  </>
                )}
              </li>
            )}
            {toggleStates.departmentFunctions && (
              <>
                {(hasPermission(permissions, ['openingStock'])) && (
                  <Link to="OpeningStockList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'Opening Stock' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('OpeningStockList');
                        setActiveLink('Opening Stock');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Opening Stock</span>}
                    </li>
                  </Link>
                )}
                {hasPermission(permissions, ['locationTransfer']) && (
                  <Link to="InventoryLocationTransferList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'InventoryLocationTransfer' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('InventoryLocationTransferList');
                        setActiveLink('InventoryLocationTransfer');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Location Transfer</span>}
                    </li>
                  </Link>
                )}
                {hasPermission(permissions, ['statusTransfer']) && (
                  <Link to="InventoryStatusTransferList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'InventoryStatusTransfer' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('InventoryStatusTransferList');
                        setActiveLink('InventoryStatusTransfer');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Status Transfer</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['transactionEntry'])) &&
                  <Link to="TransactionEntryList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'TransactionEntryList' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('TransactionEntryList');
                        setActiveLink('TransactionEntryList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Event Transactions</span>}
                    </li>
                  </Link>}
                {(hasPermission(permissions, ['unUsableProduction'])) &&
                  <Link to="UnusableProductionList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'UnusableProductionList' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('UnusableProductionList');
                        setActiveLink('UnusableProductionList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Unusable Production</span>}
                    </li>
                  </Link>}
                {(hasPermission(permissions, ['itemConversion'])) && (
                  <Link to="ItemConversionList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Item Conversion' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ItemConversionList');
                        setActiveLink('Item Conversion');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Conversion</span>}
                    </li>
                  </Link>
                )}
                 {(hasPermission(permissions, ['canteenSale'])) && (
                  <Link to="canteen-sale-list" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'canteen-sale-list' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('canteen-sale-list');
                        setActiveLink('canteen-sale-list');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Canteen Sale</span>}
                    </li>
                  </Link>
                )}
          
              </>
            )}
            {(hasPermission(permissions, ['issueRequest']) || hasPermission([permissions, 'issueSlip']) || hasPermission(permissions, ['returnSlip']) || hasPermission(permissions, ['returnAcceptance'])) && <>
              <li className="nav-heading" onClick={() => toggleNavHeading('requisition')}>
                {toggleStates.requisition ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Inter Deptt. Transfers'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Inter Deptt. Transfers'}
                  </>
                )}
              </li>
              {toggleStates.requisition && (
                <>
                  {(hasPermission(permissions, ['issueRequest'])) && (
                    <Link to="issueRequest" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'Issue Request' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('issueRequest');
                          setActiveLink('Issue Request');
                        }}
                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>Issue Request</span>}
                      </li>
                    </Link>
                  )}
                  {(hasPermission(permissions, ['issueSlip'])) && (
                    <Link to="issueSlip" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'Issue Slip' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('issueSlip');
                          setActiveLink('Issue Slip');
                        }}
                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>Issue Slip</span>}
                      </li>
                    </Link>
                  )}


                  {(hasPermission(permissions, ['returnSlip'])) && (
                    <Link to="returnSlip" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'Return Slip' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('returnSlip');
                          setActiveLink('Return Slip');
                        }}
                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>Return Slip</span>}
                      </li>
                    </Link>
                  )}
                  {(hasPermission(permissions, ['returnAcceptance'])) && (
                    <Link to="returnAcceptance" className='colourlink'>
                      <li
                        className={`nav-item ${activeLink === 'Return Acceptance' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick('returnAcceptance');
                          setActiveLink('Return Acceptance');
                        }}
                      >
                        <FontAwesomeIcon icon={faBarsProgress} />
                        {!isCollapsed && <span>Return Acceptance</span>}
                      </li>
                    </Link>
                  )}
                </>
              )}
            </>
            }
            {(hasPermission(permissions, ['securityOut']) || hasPermission(permissions, ['securityIn'])) && (
              <li className="nav-heading" onClick={() => toggleNavHeading('securityFunctions')}>
                {toggleStates.securityFunctions ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Security Functions'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Security Functions'}
                  </>
                )}
              </li>
            )}
            {toggleStates.securityFunctions && (
              <>

                {(hasPermission(permissions, ['securityIn'])) && (
                  <Link to="vehicleIn" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Security In' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('vehicleIn');
                        setActiveLink('Security In');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Security In</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['BillDetails'])) && (
                  <Link to="BillDetails" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Bill Details' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('BillDetails');
                        setActiveLink('Bill Details');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Bill Details</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['securityOut'])) && (
                  <Link to="vehicleOut" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Security Out' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('vehicleOut');
                        setActiveLink('Security Out');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Security Out</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['PendingSIReport'])) && (
                  <Link to="PendingSIReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'PendingSIReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('PendingSIReport');
                        setActiveLink('PendingSIReport');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Pending SI Report</span>}
                    </li>
                  </Link>
                )}
              </>
            )}
            {(hasPermission(permissions, ['areaProjects']) || hasPermission(permissions, ['mrInfo'])|| hasPermission(permissions, ['projectRequirement']) || hasPermission(permissions, ['requirementAssessment']) || hasPermission(permissions, ['receiptAllocation'])|| hasPermission(permissions, ['ConfirmationLetter']) || hasPermission(permissions, ['DonationLetter']) || hasPermission(permissions, ['ProjectReport']) || hasPermission(permissions, ['ProjectReport'])) && (

              <li className="nav-heading" onClick={() => toggleNavHeading('adminstration')}>
                {toggleStates.adminstration ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Adminstration'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Adminstration'}
                  </>
                )}
              </li>

            )}
            {toggleStates.adminstration && (
              <>
                {(hasPermission(permissions, ['areaProjects'])) && (
                  <Link to="areaProjectList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Area Projects' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('areaProjectList');
                        setActiveLink('Area Projects');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Area Projects</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['projectRequirement'])) && (
                  <Link to="ProjectRequirementList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'ProjectRequirementList' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ProjectRequirementList');
                        setActiveLink('ProjectRequirementList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Project Requirement</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['requirementAssessment'])) && (
                  <Link to="RequirementAssessmentListing" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'RequirementAssessmentListing' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('RequirementAssessmentListing');
                        setActiveLink('RequirementAssessmentListing');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Assessment</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['mrInfo'])) && (
                  <Link to="MRList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'MRList' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('MRList');
                        setActiveLink('MRList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Material Requisition</span>}
                    </li>
                  </Link>
                )}
                 {(hasPermission(permissions, ['receiptAllocation'])) && (
                  <Link to="receiptAllocation" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'receiptAllocation' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('receiptAllocation');
                        setActiveLink('receiptAllocation');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Receipt Allocation</span>}
                    </li>
                  </Link>
                )}
                  {(hasPermission(permissions, ['ConfirmationLetter'])) && (
                  <Link to="ConfirmationLetterList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'ConfirmationLetterList' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ConfirmationLetterList');
                        setActiveLink('ConfirmationLetterList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Confirmation Letter</span>}
                    </li>
                  </Link>
                 )} 
                {(hasPermission(permissions, ['DonationLetter'])) && (
                  <Link to="DonationLetterList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'DonationLetterList' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('DonationLetterList');
                        setActiveLink('DonationLetterList');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Donation Letter</span>}
                    </li>
                  </Link>
                )}
                {((hasPermission(permissions, ['ProjectReport'])) || (hasPermission(permissions, ['ProjectReport']))) && (
                  <Link to="AdminReports" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink == 'AdminReports' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('AdminReports');
                        setActiveLink('AdminReports');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Admin Reports</span>}
                    </li>
                  </Link>
                )}
                </>
            )}

{(hasPermission(permissions, ['accountsManagement'])) && (

<li className="nav-heading" onClick={() => toggleNavHeading('accountsManagement')}>
  {toggleStates.accountsManagement ? ( // Change the icon based on toggle state
    <>
      <FontAwesomeIcon icon={faCaretDown} />
      {!isCollapsed && ' Accounts Management'}
    </>
  ) : (
    <>
      <FontAwesomeIcon icon={faCaretRight} />
      {!isCollapsed && ' Accounts Management'}
    </>
  )}
</li>

)}
{toggleStates.accountsManagement && (
<>
    {(hasPermission(permissions, ['ConfirmationLetter'])) && (
    <Link to="voucherReceiving" className='colourlink'>
      <li
        className={`nav-item ${activeLink == 'voucherReceiving' ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          handleLinkClick('voucherReceiving');
          setActiveLink('voucherReceiving');
        }}
      >
        <FontAwesomeIcon icon={faBarsProgress} />
        {!isCollapsed && <span>Docs Mgmt</span>}
      </li>
    </Link>
   )} 
  </>
)}
            {(hasPermission(permissions, ['OpeningStockLedger']) || hasPermission(permissions, ['additionLedger']) || hasPermission(permissions, ['deductionLedger']) || hasPermission(permissions, ['LedgerInventoryReport'])) && (
              <li className="nav-heading" onClick={() => toggleNavHeading('ledgerFunctions')}>
                {toggleStates.ledgerFunctions ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Ledger Function'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Ledger Function'}
                  </>
                )}
              </li>
            )}
            {toggleStates.ledgerFunctions && (
              <>
                {(hasPermission(permissions, ['OpeningStockLedger'])) && (
                  <Link to="OpeningStockLedgerList" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'OpeningStockLedger' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('OpeningStockLedgerList');
                        setActiveLink('OpeningStockLedger');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger Opening Stock</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['additionLedger'])) && (
                  <Link to="AdditionsLedger" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'AddInventoryLedger' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('AdditionsLedger');
                        setActiveLink('AddInventoryLedger');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Additions</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['deductionLedger'])) && (
                  <Link to="DeductionsLedger" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'LessInventoryLedger' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('DeductionsLedger');
                        setActiveLink('LessInventoryLedger');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Deductions</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['LedgerInventoryReport'])) && (
                  <Link to="LedgerInventoryReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'LedgerInventoryReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('LedgerInventoryReport');
                        setActiveLink('LedgerInventoryReport');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger Inventory Report</span>}
                    </li>
                  </Link>
                )}
              </>
            )}
            {(hasPermission(permissions, ['departmentInventory']) || hasPermission(permissions, ['itemAnalysis']) || hasPermission(permissions, ['departmentItemAnalysis']) || hasPermission(permissions, ['statusWiseReport']) || hasPermission(permissions, ['eventWiseReports']) || hasPermission(permissions, ['globalItemTransaction']) || hasPermission(permissions, ['depttInventoryTransaction']) || hasPermission(permissions, ['openingStockReport']) || hasPermission(permissions, ['departmentItemList']) || hasPermission(permissions, ['itemGroupList']) || hasPermission(permissions, ['fuelReport']) || hasPermission(permissions, ['fuelConsumptionReport']) || hasPermission(permissions, ['pendingReturnable']) || hasPermission(permissions, ['PendingConsumablesLedger']) || hasPermission(permissions, ['DepartmentIssueReport'])) && (
              <li className="nav-heading" onClick={() => toggleNavHeading('reports')}>
                {toggleStates.reports ? ( // Change the icon based on toggle state
                  <>
                    <FontAwesomeIcon icon={faCaretDown} />
                    {!isCollapsed && ' Reports'}
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCaretRight} />
                    {!isCollapsed && ' Reports'}
                  </>
                )}
              </li>
            )}
            {toggleStates.reports && (
              <>
              
                {/* {(hasPermission(permissions, ['departmentInventory'])) && (
                  <Link to="DepartmentInventory" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Department Invenotry' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('DepartmentInventory');
                        setActiveLink('Department Invenotry');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Overall Deptt Invenotry</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['itemAnalysis'])) && (
                  <Link to="ItemAnalysisReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'ItemAnalysisReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ItemAnalysisReport');
                        setActiveLink('ItemAnalysisReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Overall Item Analysis</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['departmentItemAnalysis'])) && (
                  <Link to="DepartmentItemAnalysisReport" className="colourlink">
                    <li
                      className={`nav-item ${activeLink === 'DepartmentItemAnalysisReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('DepartmentItemAnalysisReport');
                        setActiveLink('DepartmentItemAnalysisReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Department Item Analysis</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['fuelReport'])) && (
                  <Link to="FuelReport" className="colourlink">
                    <li
                      className={`nav-item ${activeLink === 'FuelReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('FuelReport');
                        setActiveLink('FuelReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Fuel Report</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['fuelConsumptionReport'])) && (
                  <Link to="FuelConsumptionReport" className="colourlink">
                    <li
                      className={`nav-item ${activeLink === 'FuelConsumptionReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('FuelConsumptionReport');
                        setActiveLink('FuelConsumptionReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Fuel Consumption Report</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['statusWiseReport'])) && (
                  <Link to="StatusWiseReport" className="colourlink">
                    <li
                      className={`nav-item ${activeLink === 'StatusWiseReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('StatusWiseReport');
                        setActiveLink('StatusWiseReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Status Wise Report</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['eventWiseReports'])) && (
                  <Link to="EventWiseReport" className="colourlink">
                    <li
                      className={`nav-item ${activeLink === 'EventWiseReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('EventWiseReport');
                        setActiveLink('EventWiseReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Event Wise Report</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['globalItemTransaction'])) && (
                  <Link to="GlobalItemTransactionReport" className="colourlink">
                    <li
                      className={`nav-item ${activeLink === 'GlobalItemTransactionReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('GlobalItemTransactionReport');
                        setActiveLink('GlobalItemTransactionReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Item Ledger</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['depttInventoryTransaction'])) && (
                  <Link to="DepartmentItemTransactionReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'DepartmentItemTransactionReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('DepartmentItemTransactionReport');
                        setActiveLink('DepartmentItemTransactionReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Deptt Inventory Ledger</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['openingStockReport'])) && (
                  <Link to="OpeningStockReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'OpeningStockReport' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('OpeningStockReport');
                        setActiveLink('OpeningStockReport');
                      }}>
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Opening Stock Report</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['departmentItemList'])) && (
                  <Link to="departmentItem" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Departmental Item List' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('departmentItem');
                        setActiveLink('Departmental Item List');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Departmental Item List</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['itemGroupList'])) && (
                  <Link to="itemGroupTypeReport" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Item Group List' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('itemGroupTypeReport');
                        setActiveLink('Item Group List');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Item Group List</span>}
                    </li>
                  </Link>
                )} */}
                {/* {(hasPermission(permissions, ['pendingReturnable'])) && (
                  <Link to="pendingReturnable" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'Pending Returnable' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('pendingReturnable');
                        setActiveLink('Pending Returnable');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Pending Returnable</span>}
                    </li>
                  </Link>
                )} */}
                {(hasPermission(permissions, ['departmentInventory']) || hasPermission(permissions, ['statusWiseReport']) || hasPermission(permissions, ['eventWiseReports']) || hasPermission(permissions, ['depttInventoryTransaction']) || hasPermission(permissions, ['openingStockReport']) || hasPermission(permissions, ['departmentItemList']) || hasPermission(permissions, ['DepartmentIssueReport'])) && (
                  <Link to="DepartmentWiseReports" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'DepartmentWiseReports' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('DepartmentWiseReports');
                        setActiveLink('DepartmentWiseReports');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Deptt Wise Reports</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['itemAnalysis']) || hasPermission(permissions, ['itemGroupList']) || hasPermission(permissions, ['fuelConsumptionReport'])) && (
                  <Link to="ItemAndGroupAnalysisReports" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'ItemAndGroupAnalysisReports' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ItemAndGroupAnalysisReports');
                        setActiveLink('ItemAndGroupAnalysisReports');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Item & Group Analysis</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['globalItemTransaction']) || hasPermission(permissions, ['fuelReport']) || hasPermission(permissions, ['pendingReturnable'])) && (
                  <Link to="ItemLedgerReports" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'ItemLedgerReports' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('ItemLedgerReports');
                        setActiveLink('ItemLedgerReports');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Item Ledger Reports</span>}
                    </li>
                  </Link>
                )}
                {(hasPermission(permissions, ['LedgerInventoryReport']) || hasPermission(permissions, ['LedgerVoucherReport']) || hasPermission(permissions, ['PendingConsumablesLedger'])) && (
                  <Link to="LedgerWiseReports" className='colourlink'>
                    <li
                      className={`nav-item ${activeLink === 'LedgerWiseReports' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick('LedgerWiseReports');
                        setActiveLink('LedgerWiseReports');
                      }}
                    >
                      <FontAwesomeIcon icon={faBarsProgress} />
                      {!isCollapsed && <span>Ledger Wise Reports</span>}
                    </li>
                  </Link>
                )}
                
              </>
            )}
          </ul>
        </div>
        <div className='content-area'>
          <Routes>
            <Route path="/" element={<SewadarHomePage setUnsavedChanges={setUnsavedChanges} />} />
            <Route path="/department" element={<DepartmentPage setUnsavedChanges={setUnsavedChanges} permissions={permissions?.department} />} />
            <Route path="/ledgerGroup" element={<LedgerGroupPage setUnsavedChanges={setUnsavedChanges} permissions={permissions?.ledgerGroup} />} />
            <Route path="/ledgerMaster" element={<LedgerMasterList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.ledgerMaster} />} />
            <Route path="/addLedgerMaster" element={<LedgerMasterPage setUnsavedChanges={setUnsavedChanges} />} />
            <Route path="/purposeLedgerPage" element={<PurposePage setUnsavedChanges={setUnsavedChanges} />} />
            <Route path="/purposeLedger" element={<PurposeListing setUnsavedChanges={setUnsavedChanges} permissions={permissions?.purposeLedger} />} />
            <Route path="/purposeInventory" element={<PurposeInventory setUnsavedChanges={setUnsavedChanges} permissions={permissions?.itemEvent} />} />
            <Route path="/itemGroup" element={<ItemGroupPage setUnsavedChanges={setUnsavedChanges} permissions={permissions?.itemGroup} />} />
            <Route path="/itemMaster" element={<ItemMaster setUnsavedChanges={setUnsavedChanges} />} />
            <Route path="/ItemMasterList" element={<ItemMasterList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.itemMaster} />} />
            <Route path="/InventoryMasterListing" element={<InventoryMasterListing setUnsavedChanges={setUnsavedChanges} permissions={permissions?.itemMaster} mmsPermissions={permissions?.mmsMaping}/>} />
            <Route path="/sewadar" element={<AddSewadarForm setUnsavedChanges={setUnsavedChanges} />} />
            <Route path="/sewadarList" element={<SewadarList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.sewadar} />} />
            <Route path="/vehicleInPage" element={<SecurityIn setUnsavedChanges={setUnsavedChanges} />} />
            <Route path="/vehicleOut" element={<SecurityOutForm setUnsavedChanges={setUnsavedChanges} permissions={permissions?.securityOut} />} />
            <Route path='/addCenter' element={<AddCenter setUnsavedChanges={setUnsavedChanges} />} />
            <Route path='/addCenterIncharge' element={<CenterIncharge setUnsavedChanges={setUnsavedChanges} />} />
            <Route path='/addDeliveryChallan' element={<DeliveryChallan setUnsavedChanges={setUnsavedChanges} setRefNo={setRefNo} setPrefix={setPrefix} />} />
            <Route path='/centerList' element={<CenterList setUnsavedChanges={setUnsavedChanges} />} />
            <Route path='/uomList' element={<UOMList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.uom} />} />
            <Route path='/locationList' element={<LocationList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.stores} />} />
            <Route path='/addInventory' element={<AddInventory setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/lessInventory' element={<LessInventory setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/addReceiptVoucher' element={<ReceiptVoucher setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/addGatePass' element={<GatePass setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/gatePassList' element={<GatePassList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.gatePass} />} />
            <Route path='/itManager' element={<ITManager setUnsavedChanges={setUnsavedChanges} />} />
            <Route path='/departmentItem' element={<DepartmentItem accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/itemGroupTypeReport' element={<ItemGroupType accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/issueRequestPage' element={<IssueRequest accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/issueRequest' element={<IssueRequestTable accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.issueRequest} />} />
            <Route path='/deliveryChallanList' element={<DeliveryChallanList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.deliveryChallan} />} />
            <Route path='/testingDeliveryChallanList' element={<DeliveryChallanListTesting setUnsavedChanges={setUnsavedChanges} />} />
            <Route path='/testingDeliveryChallan' element={<TestingDeliveryChallan setUnsavedChanges={setUnsavedChanges} />} />
            <Route path='/permissions' element={<PermissionsPage setUnsavedChanges={setUnsavedChanges} />} />
            <Route path='/DepartmentInventory' element={<DepartmentInventory setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/issueSlipPage' element={<IssueSlip setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/issueSlip' element={<IssueSlipTable setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.issueSlip} />} />
            <Route path='/returnSlipPage' element={<ReturnSlip setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/returnSlip' element={<ReturnSlipTable setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.returnSlip} />} />
            <Route path='/returnAcceptancePage' element={<ReturnAcceptance setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/returnAcceptance' element={<ReturnAcceptanceTable setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.returnAcceptance} />} />
            <Route path='/additions' element={<Additions setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.additions} />} />
            <Route path='/deductions' element={<Deductions setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.deductions} />} />
            <Route path='/GlobalItemTransactionReport' element={<GlobalItemTransactionReport accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/ItemAnalysisReport' element={<ItemAnalysisReport accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/DepartmentItemAnalysisReport' element={<DepartmentItemAnalysisReport accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/DepartmentItemTransactionReport' element={<DepartmentItemTransactionReport accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/StatusWiseReport' element={<StatusWiseReport accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/EventWiseReport' element={<EventWiseReport accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/OpeningStockReport' element={<OpeningStockReport accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/itemApproval' element={<ItemMasterApproval />} />
            <Route path='/OpeningStock' element={<OpeningStock accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/OpeningStockList' element={<OpeningStockList accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.openingStock} />} />
            <Route path='/MMSMapping' element={<MMSMapping permissions={permissions?.mmsMaping} />} />
            <Route path='/operator' element={<Operator />} />
            <Route path='/operatorList' element={<OperatorList permissions={permissions?.operator} />} />
            <Route path='/ItemMasterForm' element={<ItemMasterForm />} />
            <Route path='/InventoryLocationTransfer' element={<InventoryLocationTransfer accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/InventoryLocationTransferList' element={<InventoryLocationTranferList accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.locationTransfer} />} />
            <Route path='/addAreaProjects' element={<AddAreaProjects />} />
            <Route path='/areaProjectList' element={<AreaProjectList permissions={permissions?.areaProjects} />} />
            <Route path='/InventoryStatusTransfer' element={<InventoryStatusTransfer accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/InventoryStatusTransferList' element={<InventoryStatusTransferList accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.statusTransfer} />} />
            <Route path='/ledgerApproval' element={<ApproveLedgerMaster />} />
            <Route path='/LedgerMasterForm' element={<LedgerMasterApproverForm />} />
            <Route path='/ReceiptVoucherList' element={<ReceiptVoucherList setUnsavedChanges={setUnsavedChanges} permissions={permissions?.receiptVoucher} />} />
            <Route path='/ItemConversion' element={<ItemConversion accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/ItemConversionList' element={<ItemConversionList accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.itemConversion} />} />
            <Route path='/MMSMappingForm' element={<MMSMappingForm accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/VehicleMaster' element={<VehicleMaster />} />
            <Route path='/VehicleMasterList' element={<VehicleMasterList permissions={permissions?.vehicleMaster} />} />
            <Route path='/MRInfo' element={<MRInfo accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/MRList' element={<MRList accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.mrInfo} />} />
            <Route path='/ExceptionalSecurityOut' element={<ExceptionalSecurityOut accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/vehicleIn' element={<SecurityInListing accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.securityIn} />} />
            <Route path='/BillDetails' element={<BillDetails accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.BillDetails} />} />
            <Route path='/AddSiBill' element={<AddSiBill accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/OpeningStockLedger' element={<OpeningStockLedger accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} />} />
            <Route path='/OpeningStockLedgerList' element={<OpeningStockLedgerList accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} permissions={permissions?.OpeningStockLedger} />} />
            <Route path='/AddInventoryLedger' element={<AddInventoryLedger accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} />} />
            <Route path='/AdditionsLedger' element={<AdditionsLedger accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} permissions={permissions?.additionLedger} />} />
            <Route path='/LessInventoryLedger' element={<LessInventoryLedger accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} />} />
            <Route path='/DeductionsLedger' element={<DeductionsLedger accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} permissions={permissions?.deductionLedger} />} />
            <Route path='/LedgerInventoryReport' element={<LedgerInventoryReport accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} />} />
            <Route path='/SewadarLoginLogs' element={<SewadarLoginLogs />} />
            <Route path='/ModulePermissionReport' element={<ModulePermissionReport />} />
            <Route path='/UnusableProduction' element={<UnusableProduction accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/UnusableProductionList' element={<UnusableProductionList accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.unUsableProduction} />} />
            <Route path='/TransactionEntry' element={<TransactionEntry accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/TransactionEntryList' element={<TransactionEntryList accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions?.transactionEntry} />} />
            <Route path='/ItemApprovalReport' element={<ItemApprovalReport />} />
            <Route path='/LedgerApprovalReport' element={<LedgerApprovalReport />} />
            <Route path='/sewadarReport' element={<SewadarReport />} />
            <Route path='/ItemMasterApproval' element={<ItemMasterApprovall />} />
            <Route path='/FuelReport' element={<FuelReport accessOfDepartments={sewadars?.accessOfDepartments}/>} />
            <Route path='/FuelConsumptionReport' element={<FuelConsumptionReport accessOfDepartments={sewadars?.accessOfDepartments}/>} />
            <Route path='/tam' element={<TransactionAccMgt permissions={permissions?.tam}/>} />
            <Route path='/ProjectRequirement' element={<ProjectRequirement accessOfDepartments={sewadars?.accessOfDepartments}/>} />
            <Route path='/ProjectRequirementList' element={<ProjectRequirementList permissions={permissions?.projectRequirement} accessOfDepartments={sewadars?.accessOfDepartments}/>} />
            <Route path='/VoucherStatusHandler' element={<VoucherStatusHandler permissions={permissions?.tam}/>} />
            <Route path='/pendingReturnable' element={<PendingReturnableReport permissions={permissions?.pendingReturnableChallan}/>} />
            <Route path='/receiptPendingReturnable' element={<ReceiptPendingReturnableReport permissions={permissions?.pendingReturnableReceipt}/>} />
            <Route path='/PendingTransactionReport' element={<PendingTransactionReport permissions={permissions?.tam}/>} />
            <Route path='/RequirementAssessmentListing' element={<RequirementAssessmentListing permissions={permissions?.requirementAssessment} accessOfDepartments={sewadars?.accessOfDepartments}/>} />
            <Route path='/DepartmentWiseReports' element={<DepartmentWiseReports accessOfDepartments={sewadars?.accessOfDepartments}  permissions={permissions}/>} />
            <Route path='/ItemAndGroupAnalysisReports' element={<ItemAndGroupAnalysisReports accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions}/>} />
            <Route path='/ItemLedgerReports' element={<ItemLedgerReports accessOfDepartments={sewadars?.accessOfDepartments} permissions={permissions}/>} />
            <Route path='/LedgerWiseReports' element={<LedgerWiseReports accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} permissions={permissions}/>} />
            <Route path='/receiptAllocation' element={<ReceiptAllocation accessOfDepartments={sewadars?.accessOfDepartments} accessedLedgers={sewadars?.accessedLedgers} permissions={permissions}/>} />
            <Route path='/PendingSIReport' element={<PendingSIReport/>} />
            <Route path='/ConfirmationLetterList' element={<ConfirmationLetterList/>} />
            <Route path='/addDepttReceiptVoucher' element={<DepartmentReceiptVoucher setUnsavedChanges={setUnsavedChanges} accessOfDepartments={sewadars?.accessOfDepartments} />} />
            <Route path='/seriesMaster' element={<SeriesMaster/>} />
            <Route path='/SeriesMasterList' element={<SeriesMasterList/>} />
            <Route path='/Recipe' element={<Recipe />} />
            <Route path='/RecipeList' element={<RecipeMasterList permissions={permissions?.recipe}/>} />
            <Route path='/voucherReceiving' element={<VoucherReceiving/>} />
            <Route path='/RecipeConsumption' element={<RecipeConsumption/>} />
            <Route path='/RecipeConsumptionList' element={<RecipeConsumptionList permissions={permissions?.recipeConsumption}/>} />
            <Route path='/DonationLetterList' element={<DonationLetterList />} />
            <Route path='/AdminReports' element={<AdminReports permissions={permissions}/>} />
            <Route path='/canteenSale' element={<CanteenSale/>} />
            <Route path="/canteen-sale-list" element={<CanteenSaleList />} />
            </Routes>
        </div>
      </div>
    </>
  );
};

export default Navbar;
